/** Set of pre defined filters
 * same for CLOUD and SERVER */
export const DEFAULT_FILTERS = {
  default: 'order by created DESC',
  '-1': 'assignee = currentUser() AND resolution = Unresolved order by updated DESC',
  '-2': 'reporter = currentUser() order by created DESC',
  '-3': 'issuekey in issueHistory() order by lastViewed DESC',
  '-4': 'order by created DESC',
  '-5': 'resolution = Unresolved order by priority DESC,updated DESC',
  '-6': 'created >= -1w order by created DESC',
  '-7': 'resolutiondate >= -1w order by updated DESC',
  '-8': 'updated >= -1w order by updated DESC',
  '-9': 'statusCategory = Done order by updated DESC',
};
